// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--_y1jt","content":"_7a3fb80146--content--YxGg2","price_meter":"_7a3fb80146--price_meter--MKI1I","price_total":"_7a3fb80146--price_total--wMiGK"};